import { isFieldRendereableOnSummary } from './isFieldRendereableOnSummary';

/**
 * Get the displayable filters
 *
 * @param {*} filters
 * @param {string[]} noDisplayableFilters
 * @return {*}
 */
export const getDisplayableFilters = (
    filters: any,
    noDisplayableFilters: string[]
) => {
    return Object.entries(filters).filter(([key, value]) => {
        return isFieldRendereableOnSummary(noDisplayableFilters, key, value);
    });
};
